/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-has-content */
// node modules
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import prettyMilliseconds from 'pretty-ms';
import { toSeconds, parse } from 'iso8601-duration';
import classNames from 'classnames';
import capitalize from 'lodash/capitalize';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
import CssCircularProgressbar from 'react-circular-progressbar/dist/styles.css';

// app modules: actions
import { executeCurrentStep, nextStep } from 'actions/homeconnect';

// app modules: components
import Button from 'components/Button';
import SpinnerButton from 'components/SpinnerButton';

// app modules: services
import {
  toCelsius,
  toFahrenheit,
  isCelsius,
  isFahrenheit,
  convertTemperature,
} from 'services/units';

// app modules: constants
import { APPLIANCE_CONFIG } from 'constants/content';

// assets
import CssAdjustment from './Adjustment.scss';

export function getAdjustmentText({ type, setting, duration }) {
  let temperatureInfo = '';
  if (setting.temperature_f && setting.temperature_c) {
    temperatureInfo = `${setting.temperature_f}°F/${setting.temperature_c}°C`;
  } else if (setting.value && setting.unit) {
    // This behaviour is deprecated - leaving it in for now so that our upgrade is not coupled to a data update.
    const displayTemperatureUnit = setting.unit;

    const displayTemperature = convertTemperature(
      setting.unit,
      displayTemperatureUnit,
      setting.value,
    );

    let alternativeTemperatureUnit;
    let alternativeTemperature;
    if (isFahrenheit(displayTemperatureUnit)) {
      alternativeTemperatureUnit = '°C';
      alternativeTemperature = toCelsius(setting.unit, setting.value, 5);
    } else if (isCelsius(displayTemperatureUnit)) {
      alternativeTemperatureUnit = '°F';
      alternativeTemperature = toFahrenheit(setting.unit, setting.value, 5);
    }
    temperatureInfo = `${displayTemperature}${displayTemperatureUnit}/${alternativeTemperature}${alternativeTemperatureUnit}`;
    // end of deprecated behaviour
  }
  let mode;
  if (type && APPLIANCE_CONFIG[type]) {
    mode = APPLIANCE_CONFIG[type].setting.mode[setting.mode];
  }
  if (!mode) {
    // Legacy fallback
    mode =
      (setting.mode || '').toLowerCase() === setting.mode ? capitalize(setting.mode) : setting.mode;
    if (type === 'sousvide') {
      mode = setting.mode === 'preheat' ? 'Sous vide (preheat)' : 'Sous vide';
    }
  }

  const rapidHeating = setting.rapidHeating ? 'with rapid heating' : '';
  const howLong = duration?.value
    ? `for ${prettyMilliseconds(toSeconds(parse(duration.value)) * 1000)}`
    : null;
  return [mode, temperatureInfo, rapidHeating, howLong].filter(text => !!text).join(' ');
}

class Adjustment extends Component {
  static propTypes = {
    primaryOven: PropTypes.shape({
      name: PropTypes.string,
      brand: PropTypes.string,
      status: PropTypes.objectOf(PropTypes.shape({ value: PropTypes.any, unit: PropTypes.string })),
      remoteControlActive: PropTypes.bool,
      localControlActive: PropTypes.bool,
      operationState: PropTypes.string,
      doorOpen: PropTypes.bool,
      connected: PropTypes.bool,
    }),
    stepIndex: PropTypes.number.isRequired,
    instruction: PropTypes.shape({
      type: PropTypes.string.isRequired,
      setting: PropTypes.shape({
        mode: PropTypes.string,
        unit: PropTypes.string,
        value: PropTypes.string,
      }),
      duration: PropTypes.shape({ value: PropTypes.string }),
    }).isRequired,
    onClick: PropTypes.func,
    nextStep: PropTypes.func.isRequired,
    executeCurrentStep: PropTypes.func.isRequired,
    currentStepIndex: PropTypes.number,
    activeStepIndex: PropTypes.number,
    warnings: PropTypes.arrayOf(PropTypes.string),
    userOvenBrands: PropTypes.arrayOf(PropTypes.string),
  };

  static defaultProps = {
    primaryOven: null,
    currentStepIndex: null,
    activeStepIndex: null,
    onClick: () => {},
    warnings: [],
    userOvenBrands: [],
  };

  componentDidMount() {
    this.detectStepCompletion();
  }

  componentDidUpdate(prevProps) {
    this.detectStepCompletion(prevProps);
  }

  getAdjustmentOrOverride() {
    const { instruction, primaryOven, userOvenBrands } = this.props;

    if (!primaryOven) {
      if (Array.isArray(userOvenBrands)) {
        // No oven is selected. Has the user got a preference for an oven that we should use?
        const { overrides, ...defaultAdjustment } = instruction;
        let override;
        if (overrides) {
          override = overrides.find(_override =>
            userOvenBrands.map(brand => brand.toLowerCase()).includes(_override.brand),
          );
        }
        return override || defaultAdjustment;
      }
      // No oven and no preferences - so no override needed.
      return instruction;
    }
    const { brand } = primaryOven;
    const { overrides, ...defaultAdjustment } = instruction;
    let override;
    if (overrides) {
      override = overrides.find(_override => _override.brand === brand.toLowerCase());
    }
    return override || defaultAdjustment;
  }

  detectStepCompletion(prevProps) {
    const { primaryOven, stepIndex, currentStepIndex } = this.props;
    if (!primaryOven) {
      return;
    }
    const previousFastPreHeat =
      prevProps && prevProps.primaryOven ? prevProps.primaryOven.fastPreHeat : null;
    const previousOperationState =
      prevProps && prevProps.primaryOven ? prevProps.primaryOven.operationState : null;

    const {
      haId,
      currentTemperature,
      setPointTemperature,
      preheatComplete,
      operationState,
      fastPreHeat,
    } = primaryOven;
    if (stepIndex === currentStepIndex) {
      const { setting, duration } = this.getAdjustmentOrOverride();

      if ((setting && setting.mode === 'preheat') || !duration) {
        // Detect when the target temperature is reached
        const heatingProgress = Math.round((currentTemperature / setPointTemperature) * 100);
        // Some appliances will set the preHeatComplete flag. Others we will need to track the temperature. Others will just flip the rapidHeating off...
        if (
          operationState === 'Run' &&
          setPointTemperature &&
          (preheatComplete ||
            (heatingProgress >= 85 && heatingProgress < 115) ||
            (previousFastPreHeat && !fastPreHeat))
        ) {
          this.props.nextStep({ haId });
        }
      } else if (previousOperationState === 'Finished' && operationState === 'Ready') {
        // Detect when the time is reached.
        this.props.nextStep({ haId });
      }
    }
  }

  handleSendToOvenClick = () => {
    const { primaryOven } = this.props;
    this.props.executeCurrentStep({ haId: primaryOven.haId });
  };

  isCurrentStepRunning() {
    const { primaryOven } = this.props;
    if (!primaryOven) {
      return false;
    }
    const { setting, duration } = this.getAdjustmentOrOverride();
    if (!setting) {
      return false;
    }
    const isRunning =
      primaryOven.operationState === 'Run' ||
      primaryOven.operationState === 'Pause' ||
      primaryOven.operationState === 'ActionRequired';

    const ovenSetTemp = toCelsius(
      primaryOven.setPointTemperatureUnit,
      primaryOven.setPointTemperature,
    );
    const ovenMaxTemp = toCelsius(primaryOven.setPointTemperatureUnit, primaryOven.currentMaxTemp);
    const ovenMinTemp = toCelsius(primaryOven.setPointTemperatureUnit, primaryOven.currentMinTemp);
    const desiredTemp = setting.temperature_c || toCelsius(setting.unit, setting.value);
    const roundedDesiredTemp = setting.temperature_c || toCelsius(setting.unit, setting.value, 5);

    const matchingTemperatures =
      ovenSetTemp == desiredTemp ||
      ovenSetTemp == roundedDesiredTemp ||
      (desiredTemp > ovenMaxTemp && ovenSetTemp === ovenMaxTemp) ||
      (desiredTemp < ovenMinTemp && ovenSetTemp === ovenMinTemp);

    const matchingDurations =
      (!duration?.value && primaryOven.duration === 3600) ||
      (duration?.value && primaryOven.duration == toSeconds(parse(duration.value)));
    return isRunning && matchingTemperatures && matchingDurations;
  }

  renderTimeProgress(duration) {
    const { primaryOven } = this.props;
    let { programProgress, remainingProgramTime } = primaryOven;
    const { elapsedProgramTime, activeProgram } = primaryOven;
    const durationInSeconds = toSeconds(parse(duration.value));

    if (activeProgram && activeProgram.value === 'Cooking.Oven.Program.SteamModes.SousVide') {
      // Workaround for inconsistent timing information coming back from the API for Sous Vide mode.
      // Instead of relying on the programProgress and remainingProgram time coming back from the API
      // we will calculate these values from the elapsed time because thats the only field thats
      // updated consistently for Sous Vide.
      programProgress = Math.round((elapsedProgramTime / durationInSeconds) * 100);
      remainingProgramTime = durationInSeconds - elapsedProgramTime;
    }
    return (
      <div className="adjustment__progress">
        <CircularProgressbarWithChildren
          value={programProgress || 0}
          maxValue={100}
          // Use this for pie: strokeWidth={50}
          styles={buildStyles({
            textColor: 'white',
            pathColor: '#fa6422',
            trailColor: '#a1a1a1',
            strokeLinecap: 'butt',
          })}
        >
          <p>
            {remainingProgramTime
              ? prettyMilliseconds(remainingProgramTime * 1000)
              : prettyMilliseconds(durationInSeconds * 1000)}
          </p>
        </CircularProgressbarWithChildren>
      </div>
    );
  }

  renderProgress() {
    const { setting, duration } = this.getAdjustmentOrOverride();
    if (duration) {
      return this.renderTimeProgress(duration);
    }
    return this.renderHeatingProgress(setting);
  }

  renderSendToOven() {
    const { primaryOven } = this.props;
    if (!primaryOven) {
      return (
        <Button disabled themeName="stable" size="large" className="adjustment__button">
          Send to Oven
        </Button>
      );
    }
    const {
      remoteControlActive,
      localControlActive,
      operationState,
      doorOpen,
      connected,
      awaitingManualStart,
    } = primaryOven;
    const canSendAdjustments =
      operationState !== 'Finished' && remoteControlActive && !localControlActive && !doorOpen;

    if (connected && operationState !== 'Finished') {
      return (
        <SpinnerButton
          themeName={canSendAdjustments && !awaitingManualStart ? 'energized' : 'stable'}
          disabled={!canSendAdjustments}
          size="large"
          className="adjustment__button"
          onClick={canSendAdjustments ? this.handleSendToOvenClick : () => {}}
          text={localControlActive ? 'Please Wait' : 'Send to Oven'}
          loading={awaitingManualStart}
        />
      );
    }
    return null;
  }

  renderHeatingProgress() {
    const { primaryOven } = this.props;
    if (!primaryOven) {
      return null;
    }
    const {
      currentTemperature,
      currentTemperatureUnit,
      setPointTemperature,
      setPointTemperatureUnit,
    } = primaryOven;

    if (setPointTemperature) {
      const currentTemperatureC = toCelsius(currentTemperatureUnit, currentTemperature);
      const setPointTempC = toCelsius(setPointTemperatureUnit, setPointTemperature);
      let minValue = 0;
      let maxValue = setPointTempC;
      let counterClockwise = false;
      if (currentTemperatureC > setPointTempC) {
        // Cooling required. Make it go backwards.
        minValue = 0;
        maxValue = currentTemperatureC;
        counterClockwise = true;
      }

      // The following can be used to display the temperature.
      // We currently hide it because there's a +/-15% error margin that might upset the user.
      const shouldDisplayTemp = false;
      const preheatStatus = currentTemperatureC >= maxValue ? 'Ready' : 'Heating';
      return (
        <div className="adjustment__progress">
          <CircularProgressbarWithChildren
            value={currentTemperatureC}
            minValue={minValue}
            maxValue={maxValue}
            counterClockwise={counterClockwise}
            // Use this for pie: strokeWidth={50}
            styles={buildStyles({
              textColor: 'white',
              pathColor: '#fa6422',
              trailColor: '#a1a1a1',
              strokeLinecap: 'butt',
            })}
          >
            {shouldDisplayTemp && currentTemperature
              ? `${currentTemperature}${currentTemperatureUnit}`
              : preheatStatus}
          </CircularProgressbarWithChildren>
        </div>
      );
    }
    return null;
  }

  renderActionOrProgress(isActiveStep) {
    const { currentStepIndex, stepIndex } = this.props;
    const isCurrentStep = stepIndex === currentStepIndex;
    if (isActiveStep) {
      return this.renderProgress();
    } else if (isCurrentStep) {
      return this.renderSendToOven();
    }
    return null;
  }

  renderIfCurrentStep() {
    const { primaryOven, warnings } = this.props;
    if (!primaryOven) {
      return null;
    }
    const {
      remoteStartAllowed,
      awaitingManualStart,
      localControlActive,
      doorOpen,
      remoteControlActive,
      operationState,
      connected,
      name,
      brand,
    } = primaryOven;

    return (
      <Fragment>
        {!connected ? (
          <p className="adjustment__indent">
            Lost connection to {brand} {name}
          </p>
        ) : null}
        {awaitingManualStart && !remoteStartAllowed ? (
          <p className="adjustment__indent">
            Press{' '}
            <img
              src="images/playpause.png"
              className="adjustment__playbutton"
              alt="Play/Pause button"
            />{' '}
            on the oven to begin
          </p>
        ) : null}
        {connected && !remoteControlActive ? (
          <p className="adjustment__indent">Enable Remote control on the oven</p>
        ) : null}
        {doorOpen ? <p className="adjustment__indent">Door open</p> : null}
        {localControlActive ? (
          <p className="adjustment__indent">Oven control panel in use</p>
        ) : null}
        {operationState === 'Finished' ? (
          <p className="adjustment__indent">
            Press the <span className="adjustment__endbutton">|&#x21E5; End</span> button on the
            oven to continue
          </p>
        ) : null}
        {operationState === 'Run' && warnings
          ? warnings.map(warning => (
              <p key={`warning-${warning}`} className="adjustment__indent">
                &#9432; {warning}
              </p>
            ))
          : null}
      </Fragment>
    );
  }

  render() {
    const { activeStepIndex, currentStepIndex, stepIndex, onClick, primaryOven } = this.props;
    const isActiveStep = this.isCurrentStepRunning() && stepIndex === activeStepIndex;
    const isCurrentStep = stepIndex === currentStepIndex;
    const isCompleteStep = stepIndex < currentStepIndex;

    const { type, setting, duration, skip, text } = this.getAdjustmentOrOverride();

    let content;
    if (skip || !setting) {
      if (text) {
        content = (
          <p>
            {stepIndex + 1}. {text}
          </p>
        );
      }
    } else {
      content = (
        <Fragment>
          <div>
            <p className="adjustment__heading">
              {stepIndex + 1}. {getAdjustmentText({ type, setting, duration })}
            </p>
            <p className="adjustment__indent">
              {setting.addedMoisture ? `Steam assist level: ${setting.addedMoisture}` : null}
            </p>
            {text ? <p className="adjustment__indent">{text}</p> : null}
            {setting.addedMoisture &&
            primaryOven &&
            primaryOven.operationState === 'ActionRequired' ? (
              <p className="adjustment__indent">
                <strong>Check the water reservoir level</strong>
              </p>
            ) : null}
            {isCurrentStep ? this.renderIfCurrentStep() : null}
          </div>
          {isCurrentStep ? this.renderActionOrProgress(isActiveStep) : null}
        </Fragment>
      );
    }

    if (content) {
      return (
        <div
          role="button"
          key={`adjustment_${stepIndex}`}
          className={classNames('adjustment', {
            'adjustment--current': isCurrentStep,
            'adjustment--complete': isCompleteStep,
            'adjustment--active': isActiveStep,
          })}
          onClick={isCurrentStep ? null : () => onClick(stepIndex)}
        >
          {content}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  primaryOven: state.homeConnect.primaryOven,
  recipe: state.homeConnect.recipe,
  currentStepIndex: state.homeConnect.currentStepIndex,
  activeStepIndex: state.homeConnect.activeStepIndex,
  warnings: state.homeConnect.warnings,
  userOvenBrands: state.user.oven_brands,
  unitSystem: state.user.unit_system,
});

const mapDispatchToProps = {
  executeCurrentStep,
  nextStep,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(CssAdjustment, CssCircularProgressbar)(Adjustment));
